import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-version-confirmation-dialog',
  templateUrl: './version-confirmation-dialog.component.html',
  styleUrls: ['./version-confirmation-dialog.component.scss']
})
export class VersionConfirmationDialogComponent implements OnInit {

  constructor(
            public dialoge:MatDialog,
            public notifier: NotifierService,
            private router: Router,
            @Inject(MAT_DIALOG_DATA) public data:any
  ) { 
    console.log("data",data);
  }

  ngOnInit(): void {
  }



  onContractChangeSave(){
    this.router.navigate(['/contract/request/'+this.data.uuid]);
    this.dialoge.closeAll();
  }
  doNotChangeContract(){
    this.dialoge.closeAll();
  }
}
